import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-type-oportunitie-advise',
  templateUrl: './type-oportunitie-advise.component.html',
  styleUrls: ['./type-oportunitie-advise.component.scss']
})
export class TypeOportunitieAdviseComponent {

  constructor(
    private dialogRef: MatDialogRef<TypeOportunitieAdviseComponent>
  ) { }

  public closeModal(isChange: boolean): void {
    this.dialogRef.close(isChange);
  }

}
